import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var signUpRes;
export const signUpTodo = createAsyncThunk('signUp', async (data) => {
    console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'sign_up',
            data: {
                "name": data?.values?.name,
                "user_name":data?.values?.username,
                "email": data?.values?.email,
                "dob": data?.values?.date_of_birth,
                "phoneCode": data?.values?.phonecode,
                "phone": data?.values?.phone,
                "password": data?.values?.password
            },
            headers: { "Content-Type": "application/json" }
        })
        return signUpRes = res

    } catch (error) {
        return signUpRes = error.response
    }
})